import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { MatMenuTrigger } from '@angular/material/menu';
import { AuthService } from './auth/auth.service';
import { environment } from "../environments/environment";

declare var $: any;

import {Directive, HostListener} from "@angular/core";

@Directive({
    selector: "[click-stop-propagation]"
})
export class ClickStopPropagation
{
    @HostListener("click", ["$event"])
    public onClick(event: any): void {
      event.stopPropagation();
    }

    @HostListener("mousedown", ["$event"])
    public onMousedown(event: any): void {
      event.stopPropagation();
    }    
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    authService: AuthService = null;
    env: any;
    showNotifyList: boolean = false;

    notifyListUrl: SafeResourceUrl;
    notifyPollerUrl: SafeResourceUrl;

    @ViewChild('lightbox') lightbox: ElementRef;

    constructor(private sanitizer: DomSanitizer, private authServ: AuthService) {
      this.authService = authServ;
      this.env = environment;

      this.notifyListUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.notifyListUrl);
      this.notifyPollerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.notifyPollerUrl);

    }

    /*
    @ViewChild('menuMI_INTERESSA') menuMI_INTERESSA: MatMenuTrigger;
    openOnMouseOverMI_INTERESSA() { this.menuMI_INTERESSA.openMenu(); }
    closeOnMouseOverMI_INTERESSA() { this.menuMI_INTERESSA.closeMenu(); }
    */

    ngOnInit() {
        //myFuncion();
        $(document).ready(function(){ 
          $(window).scroll(function(){
            if ($(this).scrollTop() > 100){
              $('#backtotop').fadeIn();
              $('.toptoolbar').slideUp();
              $('.menubar').slideUp();
              $('.toolbarSubtitle').hide();
              $('.toolbarContainerDiv').attr('class', 'toolbarContainerDiv mainPageMargin toolbarContainerHeightNarrow');
              $('.toolbartitle').attr('class', 'toolbartitle toolbartitleHeightNarrow');
              $('#siralogo').addClass('siralogoNarrow');
            } 
            else{
              $('#backtotop').fadeOut();
              $('.toptoolbar').slideDown();
              $('.menubar').slideDown();
              $('.toolbarSubtitle').show();
              $('.toolbarContainerDiv').attr('class', 'toolbarContainerDiv mainPageMargin toolbarContainerHeight');
              $('.toolbartitle').attr('class', 'toolbartitle toolbartitleHeight');
              $('#siralogo').removeClass('siralogoNarrow');
            }
          });
          $('#backtotop').click(function () {
              $("html, body").animate({scrollTop : 0},700);
              return false;
              });
          });

        //if(this.authService.isUserAuthenticated())
        //            alert('AUTH OK!');
    }

    loadNotificationList(e) {
      e.stopPropagation();
      e.preventDefault();

      //lightbox
      //this.notifyListUrl = env.notifyListUrl

      this.showNotifyList = true;

      // console.log('lightbox loadNotificationList');
      return false;
    }

    hideNotifyList() {
      this.showNotifyList = false;
    }

}
